module.exports = __webpack_public_path__ + "img/Realisme_Utviklingen_av_det_norske_spraaket_Aasen.a2689592.jpg";